export default __webpack_public_path__ + "static/pdp-ccb9d96f262142748496637989bc69c0.png";